import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ExpenseDirectoryPageComponent } from './components/expense-directory-page/expense-directory-page.component';
import { ChampionshipDirectoryPageComponent } from './components/championship-directory-page/championship-directory-page.component';
import { ChampionshipFormPageComponent } from './components/championship-form-page/championship-form-page.component';
import { ChampionshipViewPageComponent } from './components/championship-view-page/championship-view-page.component';
import { EventFormPageComponent } from './components/event-form-page/event-form-page.component';
import { EventViewPageComponent } from './components/event-view-page/event-view-page.component';
import { EventsPageComponent } from './components/events-page/events-page.component';
import { TeamDirectoryPageComponent } from './components/team-directory-page/team-directory-page.component';
import { TeamFormPageComponent } from './components/team-form-page/team-form-page.component';
import { TeamViewPageComponent } from './components/team-view-page/team-view-page.component';
import { TicketsPageComponent } from './components/tickets-page/tickets-page.component';
import { SeasonDirectoryPageComponent } from './components/season-directory-page/season-directory-page.component';
import { EventExpenseApiService } from './services/event-expense-api/EventExpenseApiService';
import { EventApiService } from './services/event-api/EventApiService';
import { ChampionshipApiService } from './services/championship-api/ChampionshipApiService';
import { TeamApiService } from './services/team-api/TeamApiService';
import { SeasonApiService } from './services/season-api/SeasonApiService';
import { UserManagementApiService } from '../users/services/user-management-api/UserManagementApiService';

@NgModule({
  declarations: [
    ExpenseDirectoryPageComponent,
    ChampionshipDirectoryPageComponent,
    ChampionshipFormPageComponent,
    ChampionshipViewPageComponent,
    EventFormPageComponent,
    EventViewPageComponent,
    EventsPageComponent,
    TeamDirectoryPageComponent,
    TeamFormPageComponent,
    TeamViewPageComponent,
    TicketsPageComponent,
    SeasonDirectoryPageComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
  ],
  providers: [
    provideHttpClient(),
    EventExpenseApiService,
    EventApiService,
    ChampionshipApiService,
    TeamApiService,
    SeasonApiService,
    UserManagementApiService,
  ],
  exports: [
    ExpenseDirectoryPageComponent,
    ChampionshipDirectoryPageComponent,
    ChampionshipFormPageComponent,
    ChampionshipViewPageComponent,
    EventFormPageComponent,
    EventViewPageComponent,
    EventsPageComponent,
    TeamDirectoryPageComponent,
    TeamFormPageComponent,
    TeamViewPageComponent,
    TicketsPageComponent,
    SeasonDirectoryPageComponent,
  ],
})
export class EventsModule { }
